import { Directive, HostListener, HostBinding, EventEmitter, Output, Input } from '@angular/core';
import { DragAndDropUtils } from '../dnd-upload/dnd-upload.utils';

@Directive({
  selector: '[tcaDragAndDrop]'
})
export class DndUploadDirective {
  @Input() allowedExtensions: Array<string> = [];
  @Output() private filesChangeEmiter: EventEmitter<Array<File>> = new EventEmitter();
  @Output() private invalidFilesChangeEmiter: EventEmitter<Array<File>> = new EventEmitter();

  private defaultBackgroundColor = '#F2F5FA';
  private dragOverBackgroundColor = '#e6eaf0';

  @HostBinding('style.background-color') background = this.defaultBackgroundColor;

  constructor() { }

  @HostListener('dragover', ['$event']) onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();

    this.background = this.dragOverBackgroundColor;
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    this.background = this.defaultBackgroundColor;
  }

  @HostListener('drop', ['$event']) onDrop(event) {
    event.preventDefault();
    event.stopPropagation();

    this.background = this.defaultBackgroundColor;

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      const separatedFiles = DragAndDropUtils.separateValidInvalidFiles(this.allowedExtensions, files);
      this.filesChangeEmiter.emit(separatedFiles.valid);
      this.invalidFilesChangeEmiter.emit(separatedFiles.invalid);
    }
  }
}
